// import ReactDOM from 'react-dom';

function getFieldId(fieldName, fieldPrefix) {
  return fieldPrefix !== undefined ? `${fieldPrefix}${fieldName}Field` : `${fieldName}Field`;
}

function hideField(fieldName, fieldPrefix) {
  var node = document.getElementById(getFieldId(fieldName, fieldPrefix));
  if (node) {
    node.classList.add('noDisplay');
  }
}

function showField(fieldName, fieldPrefix) {
  var node = document.getElementById(getFieldId(fieldName, fieldPrefix));
  if (node) {
    node.classList.remove('noDisplay');
  }
}

// this will override visibility rules on input elements
// Note: don't override formData in this function, that will lead to bugs.
// Note: If formData has to be changed use 'dataControlRules'
export const applyFormFieldRules = (formData, fieldName, fieldValue, fieldPrefix, isSow) => {
  if (fieldName === "eChannelType" && formData["newEchannel"] === false && document.getElementById(getFieldId('surAvailable')) !== null) {
    if (fieldValue.value.split(":").pop() === 'hsbcNet') {
      document.getElementById(getFieldId('eChannelIdOptional')).classList.add('noDisplay');
      document.getElementById(getFieldId('surAvailable')).classList.add('noDisplay');
      document.getElementById(getFieldId('sur')).classList.add('noDisplay');
    } else {
      document.getElementById(getFieldId('erpLink')).classList.add('noDisplay');
    }
  }

  // rules - toggle visibility of form fields based on new or existing E-Channel
  if (fieldName === "eChannelType" && formData["newEchannel"] === false && document.getElementById(getFieldId('singleSignOn')) !== null && document.getElementById(getFieldId('ipWhitelisting')) !== null) {
    hideField('singleSignOn', fieldPrefix);
    hideField('ipWhitelisting', fieldPrefix);
  }

  if (fieldName === "odLimit") {
    if (fieldValue !== undefined && fieldValue.toLowerCase() === "n/a") {
      hideField('unauthorizedInterestType', fieldPrefix);
      hideField('unauthorizedOD', fieldPrefix);
      hideField("odLimitTierStatus", fieldPrefix)
    } else {
      showField('unauthorizedInterestType', fieldPrefix);
      showField('unauthorizedOD', fieldPrefix);
      showField("odLimitTierStatus", fieldPrefix)
    }
  }

  if (fieldName === 'glsProductType') {
    if (fieldValue.value === 'cashcon') {
      showField('cashConTitle', fieldPrefix);
      hideField('marginApplicable', fieldPrefix);
      hideField('interestEnhancementTitle', fieldPrefix);
      hideField('location', fieldPrefix);
      hideField('notionalPoolingTitle', fieldPrefix);
      showField('relationshipBank', fieldPrefix);
    } else if (fieldValue.value === 'notionalPool') {
      hideField('cashConTitle', fieldPrefix);
      hideField('marginApplicable', fieldPrefix);
      hideField('interestEnhancementTitle', fieldPrefix);
      showField('location', fieldPrefix);
      showField('notionalPoolingTitle', fieldPrefix);
      hideField('relationshipBank', fieldPrefix);
    } else if (fieldValue.value === 'interest') {
      hideField('cashConTitle', fieldPrefix);
      showField('marginApplicable', fieldPrefix);
      showField('interestEnhancementTitle', fieldPrefix);
      hideField('location', fieldPrefix);
      hideField('notionalPoolingTitle', fieldPrefix);
      showField('relationshipBank', fieldPrefix);
    }
  }

  if (fieldName === "lendingLimit") {
    if (fieldValue !== undefined && fieldValue.toLowerCase() === "n/a") {
      hideField('lendingLimitBreachAction', fieldPrefix);
    } else if (fieldValue !== undefined && formData.accountLimit === true) {
      showField('lendingLimitBreachAction', fieldPrefix);
    }
    else if (formData.accountLimit === false) {
      hideField('lendingLimitBreachAction', fieldPrefix);
    }
  }

  if (fieldName === "borrowingLimit") {
    if (fieldValue !== undefined && fieldValue.toLowerCase() === "n/a") {
      hideField('borrowingLimitBreachAction', fieldPrefix);
    } else if (fieldValue !== undefined && formData.accountLimit === true) {
      showField('borrowingLimitBreachAction', fieldPrefix);
    }
    else if (formData.accountLimit === false) {
      hideField('borrowingLimitBreachAction', fieldPrefix);
    }
  }

  if (fieldName === "subAccountLendingLimit") {
    if (fieldValue !== undefined && fieldValue.toLowerCase() === "n/a") {
      hideField('lendingLimitBreachAction', fieldPrefix);
    } else {
      showField('lendingLimitBreachAction', fieldPrefix);
    }
  }

  if (fieldName === "subAcountBorrowingLimit") {
    if (fieldValue !== undefined && fieldValue.toLowerCase() === "n/a") {
      hideField('borrowingLimitBreachAction', fieldPrefix);
      hideField("unauthorizedOD", fieldPrefix)
    } else {
      showField('borrowingLimitBreachAction', fieldPrefix);
      showField('unauthorizedOD', fieldPrefix)
    }
  }

  const formCondition = {
    accountCreditTierStatus: {
      notiering: 'credit',
      incremental: 'accountInterestCreditTiers',
      cumulative: 'accountInterestCreditTiers'
    },
    accountDebitTierStatus: {
      notiering: 'debit',
      incremental: "accountInterestDebitTiers",
      cumulative: "accountInterestDebitTiers"
    },
    odLimitTierStatus: {
      notiering: 'unauthorizedOD',
      incremental: "odLimitTier",
      cumulative: "odLimitTier"
    },
    interestEarnTierStatus: {
      notiering: 'interestEarnings',
      incremental: "interestEarnTiers",
      cumulative: "interestEarnTiers"
    },
    interestChargesTierStatus: {
      notiering: 'interestCharges',
      incremental: "interestChargeTiers",
      cumulative: "interestChargeTiers"
    }
  }

  if (formCondition[fieldName]) {
    Object.keys(formCondition[fieldName]).map((key) => fieldValue === key ?
      showField(formCondition[fieldName][key], fieldPrefix) : hideField(formCondition[fieldName][key], fieldPrefix))
  }

  if (fieldName === 'gleNeedsRates') {
    if (fieldValue !== undefined && fieldValue === false) {
      hideField("accountCreditTierStatus", fieldPrefix)
      hideField("accountDebitTierStatus", fieldPrefix)
      hideField("creditBox", fieldPrefix)
      hideField("debitBox", fieldPrefix)
    } else {
      showField("accountCreditTierStatus", fieldPrefix)
      showField("accountDebitTierStatus", fieldPrefix)
      showField("creditBox", fieldPrefix)
      showField("debitBox", fieldPrefix)
    }
  }

  /* // Rules for showing/hiding the projectNo radiogroup based on whether GPS Implementation is true/false
  if (fieldName === 'glcmImplementation' && !formData['glcmImplementation']) {
    hideField('projectNo', fieldPrefix)
  } */
}

const formFieldsInitialRuleLookUpTable = {
  'sweep-other-sweep-instructions': {
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:zeroBalancing': {
      visibleFields: [],
      hiddenFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:creditSweep': {
      visibleFields: ['pegBalance', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop'],
      hiddenFields: ['minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:debitSweep': {
      visibleFields: ['minimumBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'debitSweepTopUp'],
      hiddenFields: ['pegBalance', 'targetBalance', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:targetBalancing': {
      visibleFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT'],
      hiddenFields: ['minSweepAmountIN', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:rangeBalancing': {
      visibleFields: ['pegBalance', 'minimumBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp'],
      hiddenFields: ['targetBalance']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:rangeBasedTargetBalancing': {
      visibleFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT'],
      hiddenFields: ['creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:percentageCreditSweep': {
      visibleFields: ['pegBalance', 'minSweepAmountOUT', 'maxSweepAmountOUT'],
      hiddenFields: ['minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:percentageDebitSweep': {
      visibleFields: ['minimumBalance', 'minSweepAmountIN', 'maxSweepAmountIN'],
      hiddenFields: ['pegBalance', 'targetBalance', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:fixedAmountSweep': {
      visibleFields: [],
      hiddenFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:drainThePool': {
      visibleFields: ['pegBalance', 'minimumBalance'],
      hiddenFields: ['targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepStandard': {
      visibleFields: [],
      hiddenFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepEnhanced': {
      visibleFields: [],
      hiddenFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepEnhancedZBA': {
      visibleFields: [],
      hiddenFields: ['pegBalance', 'minimumBalance', 'targetBalance', 'minSweepAmountIN', 'maxSweepAmountIN', 'minSweepAmountOUT', 'maxSweepAmountOUT', 'creditSweepTop', 'debitSweepTopUp']
    }
  },
  'sweep-other-sweep-options': {
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:zeroBalancing': {
      visibleFields: [],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:creditSweep': {
      visibleFields: [],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:debitSweep': {
      visibleFields: [],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:targetBalancing': {
      visibleFields: [],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:rangeBalancing': {
      visibleFields: [],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:rangeBasedTargetBalancing': {
      visibleFields: [],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:percentageCreditSweep': {
      visibleFields: ['percentage', 'percentageGroupSweepRule'],
      hiddenFields: ['fixedAmount', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:percentageDebitSweep': {
      visibleFields: ['percentage', 'percentageGroupSweepRule'],
      hiddenFields: ['fixedAmount', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:fixedAmountSweep': {
      visibleFields: ['fixedAmount'],
      hiddenFields: ['percentage', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:drainThePool': {
      visibleFields: [],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule', 'dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepStandard': {
      visibleFields: ['dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepEnhanced': {
      visibleFields: ['dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule']
    },
    'urn:hsbc:cmb:gdocs:products:taxonomies:sweepType:dynamicSweepEnhancedZBA': {
      visibleFields: ['dynamicSweepPostingMethod', 'dynamicSweepGroupSweepRule'],
      hiddenFields: ['percentage', 'fixedAmount', 'percentageGroupSweepRule']
    }
  }
};

export const applyFormFieldBulkRules = (properties = {}, formData, dynamicFormRefs) => {
  if (properties.dependentFields && formFieldsInitialRuleLookUpTable[properties.editType]) {
    properties.dependentFields.forEach(dependentFieldValue => {
      var { visibleFields, hiddenFields } = formFieldsInitialRuleLookUpTable[properties.editType][dependentFieldValue] || {};
      if (visibleFields && hiddenFields) {
        visibleFields.forEach(fieldName => {
          var node = document.getElementById(getFieldId(fieldName));
          if (node) {
            node.classList.remove('noDisplay');
          }
        });
        hiddenFields.forEach(fieldName => {
          var node = document.getElementById(getFieldId(fieldName));
          if (node) {
            node.classList.add('noDisplay');
          }
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Dynamicform/formFieldsVisibilityRules.js